/**
 * Interceptor per la conversione di risposte in formato testo in formato oggetto e contestuale conversione di datetime stringa in oggetti Date()
 * Basato su: https://stackoverflow.com/a/49279951
 */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isValidDate } from '../services/apphelper';

@Injectable()
export class AppHttpDateInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(map(event => {
      if (event instanceof HttpResponse) {
        event = event.clone({ body: this.convertDates(event.body) })
      }
      return event;
    }));
  }

  private convertDates(object: any): any {
    try {
      if (!object || !(object instanceof Object)) {
        object = JSON.parse((object as any));
      }
    } catch {
      if (isValidDate(object)) {
        return new Date(object as any);
      } else {
        object = null;
      }
    }

    if (object == null) {
      return object;
    }

    if (object instanceof Array) {
      for (const item of object) {
        this.convertDates(item);
      }
    }

    for (const key of Object.keys(object)) {
      const value = object[key];

      if (value instanceof Array) {
        for (const item of value) {
          this.convertDates(item);
        }
      }

      if (value instanceof Object) {
        this.convertDates(value);
      }

      if (isValidDate(value) && !(value instanceof Array)) {
        object[key] = new Date(value);
      }
    }

    return object;
  }
}
